import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import 'rc-slider/assets/index.css';
import { FlexRowCenterVertical, TextP } from '../../..';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';

interface Props {
  name: string;
  url: string;
}

function ResetFilter({ name, url }: Props) {
  return (
    <FilterItem>
      <ItemTitleWrapper to={url}>
        <TitleIcon
          icon={IconType.cross}
          viewBox="0 0 16 16"
          cursor="pointer"
          alt="Resetovať filter"
          marginRight={12}
          width={16}
          height={16}
          fill={'#1E398D'}
        />
        <ItemTitle>{name}</ItemTitle>
      </ItemTitleWrapper>
    </FilterItem>
  );
}

const FilterItem = styled.div`
  background: ${({ theme }) => theme.categoryFilter.bgColor};
  padding: ${({ theme }) => theme.categoryFilter.padding};
  margin: ${({ theme }) => theme.categoryFilter.margin};
  border: ${({ theme }) => theme.categoryFilter.border};
  border-radius: ${({ theme }) => theme.categoryFilter.borderRadius};

  ${({ theme }) => theme.mediab.l1050`
    padding: ${theme.categoryFilter.mobilePadding};
    margin: ${theme.categoryFilter.mobileMargin};
    border: 0;
    border-top: ${theme.categoryFilter.border};
  `}
`;

const TitleIcon = styled(SvgIcon)`
  transition: transform 0.3s ease;
  fill: ${({ theme }) => theme.colors.primary};
`;

const ItemTitle = styled(TextP)`
  font-size: ${({ theme }) => theme.categoryFilter.resetFontSize};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.categoryFilter.resetFont};
  color: ${({ theme }) => theme.categoryFilter.textColor};
`;

const ItemTitleWrapper = styled(Link)`
  cursor: pointer;
  display: flex;
  flex-flow: row;
  align-items: center;
  text-decoration: none;
`;

export { ResetFilter };
